import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { ReactiveButton } from 'bricks';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function PromoButton({
  children,
  url,
  isLarge,
  isMedium,
  isPrimary,
  isActive,
  className,
  ...otherProps
}) {
  return (
    <ReactiveButton
      className={cx('component', { large: isLarge, medium: isMedium, active: isActive }, className)}
      href={url}
      theme={isPrimary ? null : 'light'}
      isActive={isActive}
      isLarge={isLarge}
      {...otherProps}
    >
      {children}
    </ReactiveButton>
  );
}

PromoButton.propTypes = {
  /** redux props */
  children: PropTypes.node,
  isLarge: PropTypes.bool,
  isMedium: PropTypes.bool,
  isActive: PropTypes.bool,
  url: PropTypes.string,

  /** plain props */
  className: PropTypes.string,
  isPrimary: PropTypes.bool,
};
